<template>
  <div id="app">

    <!-- Pages without sidebar and navbar -->
    <div v-if="hideNavigation">
      <div>
        <router-view/>
      </div>
    </div>

    <!-- Pages with sidebar and navbar -->
    <div v-else>
      <div class="row no-gutters">
        <div class="d-none d-md-block col-md-3 col-lg-2">
          <div id="sidebar" ref="sidebar">
            <div id="sidebar-header">
              <img class="sidebar-header-logo" :src="require(`@/assets/images/b122/logo.png`)">
            </div>

            <b-nav vertical class="sidebar-list">
              <SideMenu
                :links="sidebarLinks"
                :underlinks="sideBarUnderlinks"
              ></SideMenu>
            </b-nav>
          </div>
        </div>

        <div class="col-12 col-md-9 col-lg-10">
          <b-navbar toggleable="md">
            <b-navbar-brand>
              <div class="d-md-none">
                <img class="sidebar-header-logo" :src="require(`@/assets/images/b122/logo.png`)">
              </div>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav>
                <NavBarMenu
                  :links="sidebarLinks"
                  :underlinks="sideBarUnderlinks"
                ></NavBarMenu>
                <b-nav-item class="d-md-none" @click="showMyAccountModal">{{ $t('Password') }}</b-nav-item>
                <b-nav-item class="d-md-none" @click="logout">{{ $t('Logout') }}</b-nav-item>
              </b-navbar-nav>

              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto d-none d-md-block">
                <b-nav-item-dropdown right>
                  <!-- Using 'button-content' slot -->
                  <template #button-content>
                    {{ $store.getters.username }}
                  </template>
                  <b-dropdown-item @click="showMyAccountModal">
                    {{ $t('Password') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="logout">
                    {{ $t('Logout') }}
                  </b-dropdown-item>
                </b-nav-item-dropdown>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>

          <div class="page-container">
            <router-view class="content-wrap"/>
            <div class="main-footer">
              <p>Copyright © 2022 {{ $t('TitleProject') }}.
                <span style="white-space: nowrap;">All rights reserved.</span>
              </p>
              <p style="white-space: nowrap;">Made with
                <heart-icon class="text-danger"/>
                by <a href="https://www.bleu122.com/">Bleu122</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal My Account -->
    <my-account-modal></my-account-modal>
  </div>
</template>

<script>
import MyAccountModal from "./views/user/MyAccountModal";
import SideMenu from "./views/menus/SideMenu";
import NavBarMenu from "./views/menus/NavBarMenu";

export default {

  name: 'App',

  components: {
    MyAccountModal,
    SideMenu,
    NavBarMenu
  },

  data() {
    return {
      sidebarLinks: [
        {
          "icon": "home-icon",
          "title": this.$i18n.t('Dashboard'),
          "route": "/questionnaire/index",
          "isExpendable": false,
          "routesActiveItem": ["/", "/questionnaire/index"],
        },
        {
          "icon": "user-icon",
          "title": this.$i18n.t('Users'),
          "route": "/user/index",
          "isExpendable": false,
          "routesActiveItem": ["/user/show", "/user/index"],
        }
      ],
      sideBarUnderlinks: [
        [],
      ],
    }
  },


  computed: {
    hideNavigation() {
      return !this.$store.getters.isAuthenticated
    }
  },

  methods: {
    async logout() {
      await this.$store.dispatch('LogOut')
      this.$router.push('/login')
    },

    showMyAccountModal() {
      this.$bvModal.show('my-account-modal')
    },

  }
}
</script>

<style scoped>
#sidebar {
  position: relative;
  height: 100%;
  min-height: 100vh;
  padding-top: 20px;
  background-color: var(--secondary-color);
  top: 0;
  z-index: 2;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.15);
}

#sidebar-header {
  display: flex;
  justify-content: center;
}

.sidebar-header-logo {
  width: 70%;
}

.sidebar-list {
  margin-top: 1em;
}

.main-footer {
  position: absolute;
  bottom: 0;
  width: 80vw;
  height: 3rem;
  display: flex;
  justify-content: space-between;
  margin: 0 2%;
  padding-top: 10px;
  border-top: 1px solid #D0CFCF;
}

.page-container {
  position: relative;
  min-height: 87vh;
}

.content-wrap {
  padding-bottom: 3rem; /* Footer height */
}

@media only screen and (max-width: 991px) and (min-width: 768px) {
  .main-footer {
    width: 70vw;
    height: 3.5rem;
  }

  .content-wrap {
    padding-bottom: 3.5rem; /* Footer height */
  }
}

@media only screen and (max-width: 767px) {
  .navbar {
    align-items: start;
  }

  .sidebar-header-logo {
    width: 100px;
  }

  .main-footer {
    width: 92vw;
    font-size: 12px;
    height: 3.5rem;
  }

  .content-wrap {
    padding-bottom: 3.5rem; /* Footer height */
  }

  .page-container {
    min-height: 82vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue